import EditPrinter from "@/components/management/components/printer/EditPrinter";
import PrinterTable from "@/components/management/components/printer/Printer";
import SetupPrinter from "@/components/management/components/printer/SetupPrinter";
import DevicesTable from "@/components/management/components/business/DevicesTable";
import AddDevice from "@/components/management/components/business/AddDevice";
import EditDevice from "@/components/management/components/business/EditDevice";
import { useState } from "react";
import { Navigate, useParams } from "react-router-dom";

const DevicesWrapper = () => {
  const [successMessage, setSuccessMessage] = useState("");
  const [componentToRender, setComponentToRender] = useState("devicesTable");
  const [selectedItemId, setSelectedItemId] = useState<number | null>(null);

  const handleMenuItemClick = (
    componentName: string,
    message: string = "",
    itemId: number | null = null,
  ) => {
    setComponentToRender(componentName);
    setSuccessMessage(message);
    setSelectedItemId(itemId);
  };

  if (componentToRender === "addDevice") {
    return <AddDevice onMenuItemClick={handleMenuItemClick} setSuccessMessage={setSuccessMessage} />;
  }
  
  if (componentToRender === "editDevice") {
    return <EditDevice onMenuItemClick={handleMenuItemClick} setSuccessMessage={setSuccessMessage} deviceId={selectedItemId} />;
  }
  
  return <DevicesTable onMenuItemClick={handleMenuItemClick} successMessage={successMessage} />;
};

// Redirect component that keeps the ID parameter intact
const PrinterRedirect = () => {
  const { id } = useParams();
  return <Navigate to={`/device/printers/${id}`} replace />;
};

const DeviceRoutes = [
  // New device routes
  { path: "/device", element: <Navigate to="/device/printers" replace /> },
  { path: "/device/printers", element: <PrinterTable /> },
  { path: "/device/printers/:id", element: <EditPrinter /> },
  { path: "/device/printers/setup-print", element: <SetupPrinter /> },
  { path: "/device/pos", element: <DevicesWrapper /> },
  
  // Legacy redirects for backward compatibility
  { path: "/printer", element: <Navigate to="/device/printers" replace /> },
  { path: "/printer/:id", element: <PrinterRedirect /> },
  { path: "/printer/setup-print", element: <Navigate to="/device/printers/setup-print" replace /> },
];

export default DeviceRoutes; 